module.exports = __webpack_public_path__ + "img/prize_c2.6d334450.png";